import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { dashboardActions } from "../redux/dashboard-slice";
import useHttps from "./useHttps";
import useReporting from "./useReporting";

const useDashboardData = () => {
   const { sendRequest } = useHttps();
   const dispatch = useDispatch();
   const { apiErrorReportingService } = useReporting();

   const getDonationsSuccess = (data) => {
      dispatch(dashboardActions.setDashboardResponse(data?.data));
   };

   const getDonationLoaderFunc = (value) => {
      dispatch(dashboardActions.setGetLoading(value));
   };
   const getDashboardData = useCallback(() => {
      const config = {
         method: "get",
         url: `dashboard/`,
      };

      sendRequest(
         config,
         getDonationsSuccess,
         getDonationLoaderFunc,
         apiErrorReportingService
      );
   }, [sendRequest]);

   return { getDashboardData };
};

export default useDashboardData;
